import React, {ChangeEvent} from "react";
import {connect} from "react-redux";
import "./SearchFIeld.scss";
import {debounce} from "throttle-debounce";
import {CloseCircleFilled, SearchOutlined} from "@ant-design/icons";
import {Input} from "antd";
import {getTranslate, TranslateFunction} from "react-localize-redux";
import {InputProps} from "antd/es/input";
import StoreState from "../../../interfaces/store/storeState";

interface OwnProps {
    onSearch(val?: string): void

    inputProps: InputProps
}

interface State {
    searchValue: string
}

interface StateProps {
    translate: TranslateFunction
}

type Props = OwnProps & StateProps;

class SearchField extends React.Component<Props, State> {
    private static readonly translatePath: string = "components.common.SearchField.SearchField";

    state: State = {
        searchValue: "",
    };

    static getDerivedStateFromProps(props: Props, state: State): State {
        const stateData: State = {...state};
        const {inputProps: {defaultValue}}: Props = props;
        if (defaultValue) {
            stateData.searchValue = defaultValue as string;
        }
        return stateData;
    }

    /**
     * Wait for search to be finished to call query
     */
    private debounceSearchTime: number = 400;

    /**
     * Debounce and call passed search function
     */
    search: Function = debounce(this.debounceSearchTime, this.props.onSearch);

    /**
     * Depending from where its called we firstly set state for searchValue and then search for it.
     * If its called with an empty string, we reset the field value and the list filter
     * @param {string} val
     */
    handleSearch(val: string): void {
        this.setState({
            searchValue: val,
        }, this.search(val));
    }

    render(): React.ReactNode {
        const {translate, inputProps}: Props = this.props;
        const {translatePath}: typeof SearchField = SearchField;
        const {searchValue}: State = this.state;
        return (
            <Input
                className="df-search-field"
                onChange={(e: ChangeEvent<HTMLInputElement>) => this.handleSearch(e.target.value)}
                value={searchValue}
                prefix={(
                    <SearchOutlined
                        className="df-search-icon"
                        aria-hidden
                    />
                )}
                suffix={searchValue && (
                    <CloseCircleFilled
                        onClick={this.handleSearch.bind(this, "")}
                        aria-label={translate(`${translatePath}.clearValue.text`) as string}
                    />
                )}
                {...inputProps}
            />
        );
    }
}

function mapStateToProps(state: StoreState): StateProps {
    return {
        translate: getTranslate(state.localize),
    };
}

export default connect(mapStateToProps)(SearchField);
